import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { AtiraThunk } from "../AtiraThunk";
import { SearchDto } from "../../model/search/dto/SearchDto";
import { AppAxios } from "../../axios/app/app.axios";
import { SearchResponseDto } from "../../model/search/dto/SearchResponseDto";
import { SearchKind } from "../../model/search/types/SearchKind.enum";
import { revertAllReduxAction } from "../store-reset";
import { userActions } from "../user/user.slice";

interface AppReducer {
  sideMenuCollapsed?: boolean;
  chatWidgetVisible: boolean;
  floatingTodayTasksVisible: boolean;
  //
  searchResults: SearchResponseDto;
  searchLoading?: boolean;
  searchOptions?: {
    keyword?: string;
    kind?: SearchKind;
  };
}

const initialState = Object.freeze<AppReducer>({
  sideMenuCollapsed: false,
  chatWidgetVisible: true,
  floatingTodayTasksVisible: false,
  searchResults: { results: [] },
  searchLoading: false,
  searchOptions: {
    keyword: undefined,
    kind: undefined,
  },
});

const search = AtiraThunk<SearchResponseDto, SearchDto>(
  "/search",
  AppAxios.search,
);

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setSideMenuCollapsed: (state, action) => {
      state.sideMenuCollapsed = action.payload;
    },

    setChatWidgetVisible: (state, action) => {
      state.chatWidgetVisible = action.payload;
    },

    setFloatingTodayTasksVisible: (state, action) => {
      state.floatingTodayTasksVisible = action.payload;
    },

    setSearchOptions: (
      state,
      action: { payload: AppReducer["searchOptions"] },
    ) => {
      state.searchOptions = action.payload;
    },
  },
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(search.pending, (state) => {
      state.searchLoading = true;
    });
    addCase(search.fulfilled, (state, action) => {
      state.searchResults = action.payload;
      state.searchLoading = false;
    });
    addCase(search.rejected, (state) => {
      state.searchLoading = false;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const appActions = { ...appSlice.actions, search };

export default appSlice.reducer;
